import type { RouteRecordRaw } from 'vue-router';
const actRouter: Array<RouteRecordRaw> = [
  // 首充页面
  {
    path: '/firstRecharge',
    name: 'FirstRecharge',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/firstRecharge/firstRecharge.vue'),
  },
  // 首充弹窗
  {
    path: '/fRPopup',
    name: 'PopupPage',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/firstRecharge/components/popupPage.vue'),
  },
  // 2024海上航行活动
  // {
  //   path: '/navigation',
  //   name: 'Navigation',
  //   component: () => import('@/views/activity/navigation/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // 2025宰牲节活动
  // {
  //   path: '/adjha',
  //   name: 'Adjha',
  //   component: () => import('@/views/activity/Adjha/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // staticDiagram
  {
    path: '/staticDiagram',
    name: 'StaticDiagram',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/staticDiagram/index.vue'),
  },
  // 2024赛车活动
  // {
  //   path: '/raceCar',
  //   name: 'RaceCar',
  //   component: () => import('@/views/activity/raceCar/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // 常驻等级奖励
  {
    path: '/levelRewards',
    name: 'LevelRewards',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/levelRewards/index.vue'),
  },
  // 常驻名人堂
  {
    path: '/hallOfFame',
    name: 'HallOfFame',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/hallOfFame/index.vue'),
  },
  // 名人堂-个人荣耀
  {
    path: '/personalGlory',
    name: 'PersonalGlory',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/hallOfFame/personalGlory.vue'),
  },
  // 名人堂-活动荣耀
  {
    path: '/activityGlory',
    name: 'ActivityGlory',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/hallOfFame/activityGlory.vue'),
  },
  // 名人堂-公会周年
  {
    path: '/agencyAnniversary',
    name: 'AgencyAnniversary',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/hallOfFame/agencyAnniversary.vue'),
  },
  // 名人堂-公会长生日
  {
    path: '/agencyOwnerBirthda',
    name: 'AgencyOwnerBirthda',
    meta: {
      setTitle: true,
    },
    component: () => import('@/views/activity/hallOfFame/agencyOwnerBirthda.vue'),
  },
  // //2024巴黎奥运会主会场
  // {
  //   path: '/parisOlympic',
  //   name: 'ParisOlympic',
  //   component: () => import('@/views/activity/parisOlympic/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // //2024巴黎奥运会第一阶段
  // {
  //   path: '/torchRelay',
  //   name: 'TorchRelay',
  //   component: () => import('@/views/activity/parisOlympic/components/torchRelay.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // 荣耀竞技（bb-2024巴黎奥运会第二阶段）
  // {
  //   path: '/medalRace',
  //   name: 'MedalRace',
  //   component: () => import('@/views/activity/parisOlympic/components/medalRace.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // {
  //   path: '/inviteNewUsers',
  //   name: 'InviteNewUsers',
  //   component: () => import('@/views/activity/inviteNewUsers/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // 打折活动
  // {
  //   path: '/discount',
  //   name: 'Discount',
  //   component: () => import('@/views/activity/discount/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // 七天乐活动
  // {
  //   path: '/sevenDaysOfJoy',
  //   name: 'SevenDaysOfJoy',
  //   component: () => import('@/views/activity/sevenDaysOfJoy/index.vue'),
  //   meta: {
  //     setTitle: true,
  //   },
  // },
  // {
  //   path: '/formalSevenDaysOfJoy',
  //   name: 'FormalSevenDaysOfJoy',
  //   component: () => import('@/views/activity/sevenDaysOfJoy/sevenDaysOfJoy.vue'),
  // },
  // 常驻丛林探险
  {
    path: '/jungleAdventure',
    name: 'JungleAdventure',
    component: () => import('@/views/activity/jungleAdventure/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 森林之王
  {
    path: '/kingOfTheForest',
    name: 'KingOfTheForest',
    component: () => import('@/views/activity/kingOfTheForest/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 圣诞节2025
  {
    path: '/christmas2025',
    name: 'Christmas2025',
    component: () => import('@/views/activity/christmas2025/index.vue'),
    meta: {
      setTitle: true,
    },
  },
];
const modRouter: Array<RouteRecordRaw> = [
  // 邀请页面
  {
    path: '/invitation',
    name: 'Invitation',
    component: () => import('@/views/module/invitation/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 邀请规则
  {
    path: '/inviteRules',
    name: 'InviteRules',
    component: () => import('@/views/module/invitation/components/rules.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 邀请排行榜
  {
    path: '/inviteRank',
    name: 'InviteRank',
    component: () => import('@/views/module/invitation/components/rank.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 邀请码页
  {
    path: '/inviteCode',
    name: 'InviteCode',
    component: () => import('@/views/module/invitation/components/code.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 等级页面
  {
    path: '/myLv',
    name: 'MyLv',
    component: () => import('@/views/module/myLv/myLv.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 主播认证
  {
    path: '/anchorCertification',
    name: 'AnchorCertification',
    component: () => import('@/views/module/anchorCertification/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 已认证主播
  {
    path: '/authenticatedAnchor',
    name: 'AuthenticatedAnchor',
    component: () => import('@/views/module/anchorCertification/authenticatedAnchor.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 主播记录
  {
    path: '/anchorRecord',
    name: 'AnchorRecord',
    component: () => import('@/views/module/anchorRecord/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 靓号活动
  {
    path: '/goodNumber',
    name: 'GoodNumber',
    component: () => import('@/views/module/goodNumber/goodNumber.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 靓号规则
  {
    path: '/goodNumberRule',
    name: 'GoodNumberRule',
    component: () => import('@/views/module/goodNumber/goodNumberRule.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 靓号规则
  {
    path: '/selectGoodNumber',
    name: 'SelectGoodNumber',
    component: () => import('@/views/module/goodNumber/selectGoodNumber.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 金币代理充值
  {
    path: '/agentAccount',
    name: 'AgentAccount',
    component: () => import('@/views/module/agentAccount/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 金币代理充值详情
  {
    path: '/agentdetails',
    name: 'Agentdetails',
    component: () => import('@/views/module/agentAccount/details.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 金币代理好友详情
  {
    path: '/agentfriend',
    name: 'Agentfriend',
    component: () => import('@/views/module/agentAccount/friend.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 常驻活动心愿单
  {
    path: '/wishList',
    name: 'WishList',
    component: () => import('@/views/module/wishList/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 常驻活动心愿单榜单
  {
    path: '/wishListrank',
    name: 'WishListrank',
    component: () => import('@/views/module/wishList/components/wishListrank.vue'),
    meta: {
      setTitle: true,
    },
  },
  // VIP规则页面
  {
    path: '/VIPRule',
    name: 'VIPRule',
    component: () => import('@/views/module/VIPRule/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 充值页面
  {
    path: '/residentRecharge',
    name: 'ResidentRecharge',
    component: () => import('@/views/module/residentRecharge/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // app积分转移详情
  {
    path: '/appTransferDetail',
    name: 'AppTransferDetail',
    component: () => import('@/views/module/appTransferDetail/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分页面
  {
    path: '/points',
    name: 'Points',
    component: () => import('@/views/module/points/points.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 代理工资单
  {
    path: '/agencyPayroll',
    name: 'AgencyPayroll',
    component: () => import('@/views/module/AgencyPayroll/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 代理工资单
  {
    path: '/bindGuildInfo',
    name: 'BindGuildInfo',
    component: () => import('@/views/module/AgencyPayroll/bindGuildInfo.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分账单
  {
    path: '/pointsBill',
    name: 'PointsBill',
    component: () => import('@/views/module/points/pointsBill.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分兑换金币
  {
    path: '/pointsExchange',
    name: 'PointsExchange',
    component: () => import('@/views/module/points/pointsExchange.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分兑换金币详情
  {
    path: '/pointsExchangeDetails',
    name: 'PointsExchangeDetails',
    component: () => import('@/views/module/points/pointsExchangeDetails.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分提现
  {
    path: '/pointsWithdrawal',
    name: 'PointsWithdrawal',
    component: () => import('@/views/module/points/pointsWithdrawal.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分转移
  {
    path: '/pointsTransfer',
    name: 'PointsTransfer',
    component: () => import('@/views/module/points/pointsTransfer.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分提现详情
  {
    path: '/pointsWithdrawalDetails',
    name: 'PointsWithdrawalDetails',
    component: () => import('@/views/module/points/pointsWithdrawalDetails.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 积分转移记录（我的代理积分=>进入）
  {
    path: '/pointsTransferRecord',
    name: 'PointsTransferRecord',
    component: () => import('@/views/module/points/pointsTransferRecord.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 金代列表
  {
    path: '/jinDynasty',
    name: 'JinDynasty',
    component: () => import('@/views/module/points/jinDynasty.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 订单反馈
  {
    path: '/orderFeedback',
    name: 'OrderFeedback',
    component: () => import('@/views/module/points/orderFeedback.vue'),
    meta: {
      setTitle: true,
    },
  },
  // cp榜单
  {
    path: '/cpRank',
    name: 'CpRank',
    component: () => import('@/views/module/cpRank/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 外管--高级权限 入口
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import('@/views/module/permissions/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 外管--高级权限 公会长信息认证页
  {
    path: '/agencyApply',
    name: 'AgencyApply',
    component: () => import('@/views/module/permissions/apply.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 外管--高级权限  封禁列表
  {
    path: '/banlist',
    name: 'Banlist',
    component: () => import('@/views/module/permissions/banlist.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 公会管理
  {
    path: '/management',
    name: 'Management',
    component: () => import('@/views/module/permissions/management.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 常驻cp
  {
    path: '/cpResident',
    name: 'CpResident',
    component: () => import('@/views/module/cpResident/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 每日任务
  {
    path: '/dailyTasks',
    name: 'DailyTasks',
    component: () => import('@/views/module/dailyTasks/dailyTasks.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 房间等级详情
  {
    path: '/roomLevel',
    name: 'RoomLevel',
    component: () => import('@/views/module/dailyTasks/roomLevel.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 房间等级规则

  {
    path: '/roomLevelRules',
    name: 'RoomLevelRules',
    component: () => import('@/views/module/dailyTasks/roomLevelRules.vue'),
    meta: {
      setTitle: true,
    },
  },
  // 背景管理
  {
    path: '/backgroundManagement',
    name: 'BackgroundManagement',
    component: () => import('@/views/module/permissions/backgroundManagement.vue'),
  },
  // 背景管理记录
  {
    path: '/backgroundRecord',
    name: 'BackgroundRecord',
    component: () => import('@/views/module/permissions/backgroundRecord.vue'),
  },
  // 赠送管理
  {
    path: '/handselManagement',
    name: 'HandselManagement',
    component: () => import('@/views/module/permissions/handselManagement.vue'),
  },
  // 赠送记录
  {
    path: '/handselManagementRecord',
    name: 'HandselManagementRecord',
    component: () => import('@/views/module/permissions/handselManagementRecord.vue'),
  },
  // 其他权限
  {
    path: '/otherPermissions',
    name: 'OtherPermissions',
    component: () => import('@/views/module/permissions/otherPermissions.vue'),
  },
  //每月首充规则
  {
    path: '/firstChargeRule',
    name: 'FirstChargeRule',
    component: () => import('@/views/module/firstChargeRule/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  //账单说明
  {
    path: '/billExplanation',
    name: 'BillExplanation',
    component: () => import('@/views/module/billExplanation/index.vue'),
    meta: {
      setTitle: true,
    },
  },
  //开关说明
  {
    path: '/switchInstructions',
    name: 'SwitchInstructions',
    component: () => import('@/views/module/switchInstructions/index.vue'),
    meta: {
      setTitle: true,
    },
  },
];

const routes = () => {
  return [...actRouter, ...modRouter];
};

export default routes;
